<!-- 幸运抽奖 -->
<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img class="pointer" @click="returnBack()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <!-- <div class="headReturn" v-if="localStepNum == 0">
      <span @click="returnBack"> <i class="iconfont iconicon_fanhui" style="font-size:14px"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">{{ activityData.name }}</span>
    </div> -->
    <!-- 步骤条 -->
    <!-- <div class="step">
      <el-steps class="bz" :space="300" :active="localStepNum" finish-status="success">
        <el-step title="活动模板"></el-step>
        <el-step title="设置规则"></el-step>
        <el-step title="完成发布"></el-step>
      </el-steps>
    </div> -->
    <div :class="{ formBox: localStepNum != 0 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 0">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                @click="handleNav(item,index)"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div class="temImg_content" @click="handleOpen()" style="border: 1px solid rgba(123,97,255,0.15);">
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div class="temImg_content_wz" style="background: rgba(123, 97, 255, 0.05);"></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="(item, index) in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img class="imgs" style="width:100%;" :src="activityData.id == 8 ? item.secondImageUrl : item.imageUrl" alt="" />
                  <img v-if="item.days" class="temImg_content_img_free" src="@/assets/thdImg/common/free.svg" alt="" srcset="" />
                  <div v-if="item.days" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div class="temImg_content_bgshadow_code qrCodeIMG" id="queryId" ref="queryId"></div>
                <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(index + 1, item.id, item)">使用此模板</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="140px">
          <div class="newsInfo">基本信息</div>
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input v-model="ruleForm.activityName" :disabled="activityData.isStart" maxlength="15" show-word-limit placeholder="请输入活动名称" style="width: 400px"></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <!-- <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" /> -->
              <el-date-picker
                prefix-icon="no_icon"
                v-model="activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearTime()"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天 <span style="color: #7B61FF">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>
          <el-form-item label="活动参与对象:" prop="partner">
            <el-checkbox-group v-model="ruleForm.partner" @change="checkListchange" :disabled="activityData.isStart">
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox label="0" name="partner" :disabled="ruleForm.partner == -1">非会员</el-checkbox>
              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
            <span v-if="localStepNum == 3">注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span>

            <div style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="activityData.isStart">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||activityData.isStart">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||activityData.isStart">
                </el-date-picker>
                <i v-if="!activityData.isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span  style="color:red">注意：该条件对【非会员】身份不生效</span>

          </el-form-item>

          <!-- 1.14迭代 plus会员限制 -->
          <el-form-item label="Plus会员身份:" required>
            <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="activityData.isStart">不限</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="activityData.isStart">Plus会员</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="activityData.isStart">非plus会员</el-radio>
            <div style="color:red">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <!-- prop="isFollow" 是否关注店铺 -->
            <el-checkbox label="关注店铺后方可参与活动" v-model="ruleForm.condFollow" :disabled="activityData.isStart"></el-checkbox>
          </el-form-item>
          <div class="newsInfo">抽奖机会</div>
          <el-form-item label="获取抽奖机会方式:" required>
            <el-radio v-model="raffleForm.drawType" :disabled="activityData.isStart" :label="1">任务赠送</el-radio>
            <el-radio v-model="raffleForm.drawType" :disabled="activityData.isStart" :label="0">消耗积分</el-radio>
          </el-form-item>
          <el-form-item label="免费赠送:"  v-if="raffleForm.drawType == 1">
            <el-radio :label="1" v-model="raffleForm.taskType">
              首次赠送
              <el-input
                v-model.number="raffleForm.firstGiveTimes"
                placeholder="请输入..."
                @input="raffleForm.firstGiveTimes = getNumberData(1, $event, 0, 0)"
                style="width: 70px"
                :disabled="activityData.isStart"
              ></el-input>
              次
            </el-radio>
            <el-radio :label="2" v-model="raffleForm.taskType">
                每天
              <el-input
                v-model.number="raffleForm.everyDayGiveTimes"
                placeholder="请输入..."
                @input="raffleForm.everyDayGiveTimes = getNumberData(1, $event, 0, 0)"
                style="width: 70px"
                :disabled="activityData.isStart"
              ></el-input>
              次
            </el-radio>
          </el-form-item>
          <el-form-item label="积分抽奖:" required v-else>
            用户消耗
            <el-input v-model.number="raffleForm.point" :disabled="activityData.isStart" placeholder="请输入..." style="width: 80px" @input="bigTurntable.point = getNumberData(1, $event, 0, 1)"></el-input>
            积分抽奖一次
          </el-form-item>
          <el-form-item label="赠送限制:" v-if="raffleForm.drawType == 1">
            <el-radio :label="0" v-model="raffleForm.giveLimitType" :disabled="activityData.isStart">
              不限制
            </el-radio>
            <el-radio :label="1" v-model="raffleForm.giveLimitType" :disabled="activityData.isStart">
              满足参与身份才赠送机会
            </el-radio>
          </el-form-item>
          <el-form-item label="任务获取:" v-if="raffleForm.drawType == 1">
            <div class="task-btn-wrap">
              <el-button v-if="!activityData.isStart" type="primary" @click="addTask">+添加任务</el-button>
            </div>
            <el-table
              v-if="taskDataList.length > 0"
              :data="taskDataList"
              style="width: 100%; border: 1px solid #f0f0f0"
              :header-cell-style="{ background: '#fafafa'}"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="任务" width="80px">
                <template slot-scope="scope">
                  <span>任务{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务类型">
                <template slot-scope="scope">
                  <span>{{getTaskType(scope.row.type)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务条件" prop="condition">
                <template slot-scope="scope">
                  <span style="white-space: pre;">{{getCondition(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务次数" prop="count">
                <template slot-scope="scope">
                  <span>{{getCount(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button class="normal-btn" :disabled="activityData.isStart" type="text" @click="editTask(scope.row,false)">修改</el-button>
                  <el-button class="normal-btn" type="text" @click="editTask(scope.row,true)">查看</el-button>
                  <el-button class="normal-btn" :disabled="activityData.isStart" type="text" @click="deleteTask(scope.row)">删除</el-button>
                  <el-button class="normal-btn" :disabled="activityData.isStart" type="text" @click="upTask(scope.$index)" v-if="scope.$index != 0">上移</el-button>
                  <el-button class="normal-btn" :disabled="activityData.isStart" type="text" @click="downTask(scope.$index)" v-if="scope.$index != taskDataList.length - 1">下移</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <div class="newsInfo">奖品设置</div>
          <el-form-item label="抽奖和中奖限制:">
            <div class="limit">
              <p>
                每人<span class="c">每天</span>最多抽奖次数
                <el-input
                  v-model.number="bigTurntable.oneDayMaxDrawNumber"
                  placeholder="请输入..."
                  @input="bigTurntable.oneDayMaxDrawNumber = getNumberData(1, $event, 0, 1)"
                  style="width: 70px"
                  :disabled="activityData.isStart"
                ></el-input>
                次, 活动期间<span class="c">累计抽奖</span>最多
                <el-input
                  v-model.number="bigTurntable.totalMaxDrawNumber"
                  placeholder="请输入..."
                  @input="bigTurntable.totalMaxDrawNumber = getNumberData(1, $event, 0, 1)"
                  style="width: 70px"
                  :disabled="activityData.isStart"
                ></el-input>
                次,
              </p>
              <p>
                活动期间每人<span class="c">每天</span>中奖不超过
                <el-input
                  v-model.number="bigTurntable.oneDayMaxRewardNumber"
                  placeholder="请输入..."
                  style="width: 70px"
                  @input="bigTurntable.oneDayMaxRewardNumber = getNumberData(1, $event, 0, 1)"
                  :disabled="activityData.isStart"
                ></el-input>
                次, <span class="c">累计</span>中奖不超过
                <el-input
                  v-model.number="bigTurntable.totalMaxRewardNumber"
                  placeholder="请输入..."
                  style="width: 70px"
                  @input="bigTurntable.totalMaxRewardNumber = getNumberData(1, $event, 0, 1)"
                  :disabled="activityData.isStart"
                ></el-input>
                次,
              </p>
              <p class="desc">
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0 3px;
                "
                />
                此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
              </p>
            </div>
          </el-form-item>
          <!-- 概率配置 -->
          <el-form-item label="概率配置类型:">
            <el-radio-group @change="handleProbabilityChange" v-model="probabilityType">
              <el-radio 
                v-for="option in probabilityConfigOptions" 
                :key="option.value" 
                :label="option.value"
              >
                {{ option.label }}
              </el-radio>
            </el-radio-group>
            <el-tooltip class="item" effect="dark" placement="bottom">
              <template slot="content">
                <div>固定概率：所有抽奖机会概率均一致；</div>
                <div>按任务配置概率：可选择通过指定任务获取的抽奖机会进行单独配置中奖概率；</div>
              </template>
              <el-button type="text" style="width: 35px;">
                <i style="color: #ccc" class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <!-- 按任务配置时显示任务选择 -->
          <el-form-item v-if="probabilityType == 1" label="选择任务:">
            <el-checkbox-group v-model="selectedTaskTypes" @change="handleTaskTypesChange" >
              <el-checkbox 
                v-for="task in availableTaskOptions" 
                :key="task.value" 
                :label="task.value"
              >
                {{ task.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- 按任务配置时显示的tab栏 -->
          <el-form-item v-if="probabilityType == 1 && selectedTaskTypes.length > 0">
            <el-tabs class="tab-roi-box" v-model="activeProbabilityTab" @tab-click="handleTabClick">
              <el-tab-pane 
                v-for="tab in dynamicProbabilityTabs" 
                :key="tab.name"
                :label="tab.label" 
                :name="tab.name"
              >
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img src="../../assets/images/integralCenter/wzsyt.png" alt="" />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <el-table
              :data="currentPrizeList"
              style="width: 100%; border: 1px solid #f0f0f0"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="位置" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                  <span v-if="scope.row.index == 8">九</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span v-if="!isTaskTab && !activityData.isStart" class="s" @click="centerVis(scope.row)">选奖品</span>
                  <span v-else>选奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{getPrizeTypeName(scope.row.prizeType)}}</span>
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price">
                <!-- <template slot-scope="scope">
                {{ scope.row.price }}
              </template> -->
              </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    maxlength="12"
                    :disabled="(scope.row.prizeType != 3||scope.row.isGoodManage) || activityData.isStart || isTaskTab"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = checkputn(e, scope.row, 'jindou'))"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1),prizeNum(scope.row)"
                    @blur="beAdd(scope.row)"
                    :disabled="isTaskTab || activityData.isStart && !scope.row.minNum || activityData.isStart"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="每日发放限额" width="180">
                <template slot-scope="scope">
                  <!-- <el-input
                    v-model.number="scope.row.dailyLimit"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.dailyLimit = checkLimit(scope.row,1)"
                    :disabled="!activityData.status ? false : !scope.row.totalAmount ? true : false"
                  ></el-input>
                  份 -->
                  <div style="text-align: center" @click="setLimit(scope.row)">
                    <el-button :disabled="isTaskTab || activityData.isStart" v-if="!scope.row.dailyLimitType && !scope.row.dailyLimit" type="text">
                      配置
                    </el-button>
                    <el-button :disabled="isTaskTab || activityData.isStart" v-if="scope.row.dailyLimitType == 0 && scope.row.dailyLimit" type="text">
                      每日发放{{ scope.row.dailyLimit }}份
                    </el-button>
                    <div v-if="scope.row.dailyLimitType == 1">
                      <div>
                        <el-button :disabled="isTaskTab || activityData.isStart" type="text">闲时发放{{ scope.row.idleLimit }}份</el-button>
                      </div>
                      <div>
                        <el-button :disabled="isTaskTab || activityData.isStart" type="text">忙时发放{{ scope.row.busyLimit }}份</el-button>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

<!--                     @input="scope.row.percentage = handleInputPrice($event)" -->
              <el-table-column label="中奖率" width="120">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.percentage"
                    placeholder="请输入..."
                    style="width: 70px"
                    @keyup.native="scope.row.percentage = oninput2(scope.row.percentage,scope.$index)"
                    :disabled="!activityData.status ? false : !scope.row.totalAmount ? true : false"
                  ></el-input>
                  %
                </template>
              </el-table-column>
              <el-table-column label="最多中奖次数" width="120">
                  <template #header>
                    <el-tooltip
                      effect="light"
                      content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
                      placement="right"
                    >
                      <div>
                        最多中奖次数<i style="color: #ccc;" class="el-icon-question"></i>
                      </div>
                    </el-tooltip>
                  </template>
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.singleMaxWin"
                    @input="scope.row.singleMaxWin = getNumberData(1, $event, 1, 0, 9999)"
                    :disabled="isTaskTab || !activityData.status ? isTaskTab ? true : false : !scope.row.totalAmount ? true : activityData.isStart ? true : false"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="图片" width="170">
                <template slot-scope="scope">
                  <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 56px; height: 56px" />
                </template>
              </el-table-column>
              <el-table-column label="入会且已购中奖率" width="150">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.memberBuyPercentage"
                    @input="scope.row.memberBuyPercentage = getNumberData(1, $event, 1, 0,100)"
                    placeholder="请输入..."
                    style="width: 70px"
                    @keyup.native="scope.row.memberBuyPercentage = oninput2(scope.row.memberBuyPercentage,scope.$index,2)"
                    :disabled="!activityData.status ? false : !scope.row.totalAmount ? true : false"
                  ></el-input>
                  %
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <span v-if="!activityData.isStart && !isTaskTab" class="s" @click="cleanData(scope.row, scope.$index)">清除</span>
                  <span v-else>清除</span>
                  <el-button type="text" style="margin-left: 5px" v-if="activityData.isStart && scope.row.title && scope.row.title !='谢谢参与'"
                    @click="itemAddNum('prizeSettingList', scope.$index)">增加奖品数量</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="tips tipBg">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 9px 4px 0 3px;
          "
              />
              <span style="margin-left:21px"> 说明</span>
              <p>
                1、最多设置{{luckyDrawForm==4?6:luckyDrawForm == 3?9:8}}个奖项；设置的奖项不足{{luckyDrawForm==4?6:luckyDrawForm == 3?9:8}}个时，系统自动补充“谢谢参与”
              </p>
              <p>
                2、中奖率/入会且已购中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
              </p>
              <p>3、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担；</p>
              <p>4、进行中的活动修改中奖概率有一定客诉风险，不建议频繁修改。</p>
              <!-- <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p>
              <p>
                4、实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
              </p> -->
            </div>
          </el-form-item>
          <orderShopInfo v-model="customerPaperwork"/>
          <div class="newsInfo">进店设置</div>
          <el-form-item label="进店逛逛:">
            <el-radio-group v-model="ruleForm.goShopSetting" :disabled="activityData.isStart" @change="onShopSetChange">
             <el-radio :label="0">进入店铺首页</el-radio>
             <el-radio :label="1">跳转指定小程序</el-radio>
             <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color:#F56C6C">部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券、下单抽奖</div>
          </el-form-item>
          <div v-if="ruleForm.goShopSetting==1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
           <el-form-item label="页面路径path:">
            <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            <div style="color:#F56C6C">注意：path若不写，则默认进入小程序主页。</div>
           </el-form-item>
          </div>
          <el-form-item label="指定链接:" required v-if="ruleForm.goShopSetting==2">
            <el-input
                type="textarea"
                placeholder="请输入指定链接"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
            ></el-input>
            <div style="color:#F56C6C">注意：仅可填写京东域内的 H5页面地址，不可设置外链。参考链接：https://m.jd.com/。</div>
          </el-form-item>

          <div class="newsInfo">曝光商品</div>
          <el-form-item label="曝光商品:">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px;display: inline-block;"
              :class="[{ add_btn1: ruleForm.exposureSwitch },'zindexBox']"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
              <!-- <el-radio :label="1">显示促销价</el-radio> -->
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <div class="newsInfo">分享设置</div>
          <el-form-item label="小程序分享标题:" required label-width="125">
            <el-input
                type="text"
                style="width: 400px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                @input="inp"
                :disabled="activityData.isStart"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required label-width="125">
            <el-input
                type="text"
                style="width: 400px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                @input="inp"
                :disabled="activityData.isStart"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required label-width="130">
            <div class="miniAppPic" style="margin-left:16px;">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="activityData.isStart"
                  >
                  <el-button size="mideal" class="returnBtn" :disabled="activityData.isStart">自定义上传</el-button>
                </el-upload>
                <span v-if="!activityData.isStart" class="reset" @click="picUrlReset1">重置</span>
                <span v-else class="reset" style="cursor:default;">重置</span>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="newsInfo">活动规则</div>
          <el-form-item label="规则内容:" required>
            <div style="width: 570px;padding: 8px;">
              <el-input
                maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
              ></el-input>

              <div>
                <el-button type="primary" class="generate" plain @click="generateRule">生成规则</el-button>
                <span class="desc">
                  <img
                    src="@/assets/images/new_icon_reminder.png"
                    style="
                      display: inline-block;
                      float: left;
                      position: absolute;
                      width: 14px;
                      height: 14px;
                      color: #ffffff;
                      margin: 17px 4px 0px -13px;
                    "
                  />
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </span>
              </div>
            </div>
          </el-form-item>
          <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity" style="height: calc(100% - 45px);"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 0">
      <el-button v-show="!itemId" class="returnBtn" size="medium" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
      }}</el-button>
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button v-show="!itemId" class="keepBtn" v-if="isSave" type="primary" size="medium" @click="resetForm" v-preventReClick
          >保存并完成设置</el-button
        >
      </template>

      <el-button v-show="itemId" class="returnBtn" size="medium" @click="cancelEdit">取消</el-button>
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium">保存并完成设置</el-button>
    </div>
    
    <!-- 添加任务 -->
    <selectGoodsMonitor
      ref="selectTaskGoods"
      :isShow="goodsState"
      @close="selectGoodsChange"
      :selectGoods="selectGoodsSkuList"
      :numlimit="goodsLimit"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
    ></selectGoodsMonitor>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      :isSupportVirtualGroup="true"
    ></selectGoodsMonitor>

    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" activityType="8" :endTime="activityEndTime" v-if="isSelectProduct" :echoDate="echoDate" :actId="valueRow" :num="1" :JingdouCount="JingdouCount" @choose-shop="getTheData">
    </selectProduct>
    <!-- 添加任务 -->
    <el-dialog :title="`${isTaskEdit?'修改任务':'添加任务'}`" :visible.sync="taskDialog" :width="taskForm.type==17?'800px':'670px'" @close="taskClose" v-if="taskDialog" append-to-body>
      <el-form :model="taskForm" style="position: relative;" class="new-input-box" label-position="left">
        <el-form-item label="任务类型:" label-width="100px" required>
          <div v-if="taskIsLook" style="position:absolute;width: 100%;height: 100%;left: 0;top:0;z-index: 1;"></div>
          <el-select
            v-model="taskForm.type" 
            style="width: 350px"
            @change="taskTypeChange"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="task-tip-wrap">
          <tip-box class="task-tip" v-if="taskForm.type == 1">
            <div>任务说明：用户每日都可进入活动页签到，获得抽奖机会。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 2">
            <div>任务说明：用户每日都可进入活动页浏览店铺，获得抽奖机会。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 13">
            <div>任务说明：</div>
            <div>1.用户浏览商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，浏览同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 4">
            <div>任务说明：</div>
            <div>1.用户成功加购商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 9">
            <div>任务说明：</div>
            <div>1.用户成功分享商品可以获得抽奖机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 10">
            <div>任务说明：</div>
            <div>1.用户成功分享店铺可以获得抽奖机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 11">
            <div>任务说明：</div>
            <div>1.用户成功分享活动可以获得抽奖机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 8">
            <div>任务说明：</div>
            <div>1.用户成功邀请好友可以获得抽奖机会；</div>
            <div>2.被邀请人只有点击助力链接才算一次有效助力，且活动期间每人只有1次助力机会；</div>
            <div>3.用户在活动期间内可以做此任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 5">
            <div>任务说明：</div>
            <div>1.此任务可以放链接，必须遵从以下规则：</div>
            <div>
              （1） 链接须包含 .isvjcloud.com，.isvjd.com或.jd.com
            </div>
            <div>
              （2） 只能以http://,https://开头
            </div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 12">
            <div>任务说明：</div>
            <div>1.用户成功预约商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，预约同一个商品多次按1次计算；</div>
            <div>3.用户在活动时间期间内可以做此任务。</div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 16">
            <div>任务说明：用户消耗一定积分可兑换抽奖机会次数。</div>
          </tip-box>
          <tip-box class="task-tip"  v-if="taskForm.type == 17">
            <div>
              <div>任务说明：</div>
              <div>
                1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（非实付）；
              </div>
              <div>2、指定购买商品：订单包含任意指定商品均会被统计；</div>
              <div>
                3、选择订单状态为“已完成”，则仅限交易完成的订单可获得抽奖机会，如：活动已结束，交易未完成，则不赠送次数；
              </div>
              <div>
                4、如买家通过消费任务获得次数后进行退款的情况，已赠送的次数不会撤回；
              </div>
              <div style="color: #fe4d45">
                5、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。
              </div>
            </div>
          </tip-box>
          <tip-box class="task-tip" v-if="taskForm.type == 18">
            <div>任务说明：用户邀请好友成功入会，可获取中奖机会；</div>
          </tip-box>
        </div>
        <el-form-item label="任务有效期:" label-width="110px" required>
          <div class="task-wrap">
            <div class="task-wrap-radio">
              <el-radio v-model="taskForm.taskTime" :label="1">长期有效</el-radio>
              <el-radio v-model="taskForm.taskTime" :label="2">指定日期</el-radio>
            </div>
            <div class="my_select_time" v-if="taskForm.taskTime == 2">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.startTime"
                  type="date"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  @change="activityTimeChange"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.endTime"
                  type="date"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 120px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearTaskTime()"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="邀请人数上限:" label-width="110px" required v-if="taskForm.type == 8">
          <span>
            <el-input
              v-model.number="taskForm.inviteLimit"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.inviteLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
          </span>
          人
        </el-form-item>
        <el-form-item label="跳转链接:" label-width="110px" required v-if="taskForm.type == 5">
          <el-input
            v-model="taskForm.jumpUrl"
          ></el-input>
          <div>
            <span class="tip-red">注：跳转的链接必须为京东链接</span>
          </div>
        </el-form-item>
        <!-- 购买商品 -->
        <template v-if="taskForm.type == 17">
          <el-form-item label="奖励规则："  label-width="110px" required>
            <el-select
              v-model="taskForm.giveType" 
              style="width: 200px"
              @change="giveTypeChange">
              <el-option
                v-for="item in rewardRulesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="light" placement="right" style="margin-left: 8px">
              <div slot="content">
                1、按固定次数赠送抽奖机会：例如设置【满10元及以上赠送1次机会】，若用户下单100元，则也只赠送1次机会；
                <br/>
                2、按倍数赠送抽奖机会：例如设置【每满100元及以上赠送1次机会】，若按单笔，则用户第一次下单90元，则未达到赠送条件，第二次下单110元，则赠送1次机会；
                <br/>
                若按累计，则用户第一次下单90元，未达到赠送条件；第二次下单110元，两笔订单合起来为200元，则赠送2次抽奖机会
                <br/>
                3、按阶梯赠送抽奖机会：例如设置多阶梯【满10元及以上赠送1次机会，满30元及以上赠送3次机会】，若按单笔，用户第一次下单10元，则赠送1次机会，第二次下单20元，满足“满10元未达到30元”，则赠送1次
                <br/>
                若按累计，用户下单10元，则本次赠送1次机会，该用户再次下单20元，此时满足第二个阶梯30元，但是由于已经赠送了1次机会，所以再次赠送2次机会。达到满30元赠送3次机会的设置。
                <br/>
              </div>
              <div style="display: inline-flex;cursor: pointer;align-items: center;">
                奖励规则说明<i class="el-icon-question" style="color: #ccc;margin-left: 2px;"></i>
              </div>
            </el-tooltip>
            <div class="rule_box">
            <el-form-item label="下单时间：" label-width="100px" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.orderStartTime"
                  :picker-options="taskstartpickerOptionsValue"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 148px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.orderEndTime"
                  :picker-options="taskpickerOptionsValueEnd"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59"
                  style="width: 152px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearOrderTime()"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <el-tooltip class="item" effect="light" content="最长时间跨度不超过90天" placement="bottom" style="margin-left: 8px">
                <div style="width: 35px; display: inline-flex;cursor: pointer;">
                  <i class="el-icon-question" style="color: #ccc"></i>
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="金额统计类型:" required>
              <el-radio-group
                v-model="taskForm.orderPaymentType"
              >
                <el-radio :label="1">
                  <span>订单金额（后台价）</span>
                  <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                    <i class="el-icon-question" style="color: #ccc"></i>
                  </el-tooltip>
                </el-radio>
                <el-radio :label="0" v-if="!venderType">
                  <span>用户应付金额</span>
                  <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                    <i class="el-icon-question ml8" style="color: #ccc"></i>
                  </el-tooltip>
                </el-radio>
                <el-radio :label="2" v-if="!venderType">
                  <span>用户实付金额</span>
                  <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                    <i class="el-icon-question ml8" style="color: #ccc"></i>
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
            </el-form-item>
              <el-form-item label="商品要求：" label-width="100px" required class="skuType-label">
                <el-radio v-model="taskForm.skuType" :label="0" @change="handleChangeSku">全部商品</el-radio>
                <el-radio v-model="taskForm.skuType" :label="1"  @change="handleChangeSku">指定商品</el-radio>
                <div style="display: inline-block">
                  <el-button type="blue" style="width: auto;" @click="showGoods(500)" :disabled="taskForm.skuType != 1">选择商品({{selectGoodsSkuList.length}}/500)</el-button>
                </div>
              </el-form-item>
              <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
              <el-form-item label="指定商品规则：" label-width="100px" v-if="taskForm.orderPaymentType==1&&taskForm.skuType == 1">
                <el-select style="width: 280px;" v-model="taskForm.statsSkuType" placeholder="请选择">
                  <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                  <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单金额：" v-if="taskForm.giveType == 0"  label-width="100px" required>
                大于等于<el-input style="width: 120px; margin: 0 8px"  v-model="taskForm.amtLimit" @input="validateInput"/>元
              </el-form-item>
              <el-form-item label="商品件数：" v-if="taskForm.giveType == 0" style="margin-left: 12px"  label-width="88px">
                大于等于<el-input style="width: 120px; margin: 0 8px" v-model="taskForm.itemTotalLimit" @input="validateInputNew"/>件
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <el-button type="text" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</el-button>
              </el-form-item>
              <el-form-item label="订单状态："  label-width="100px" required>
                <el-radio-group v-model="taskForm.orderType" @change="handleChangeOrderType">
                  <el-radio :label="0">已付款</el-radio>
                  <el-radio :label="1">已完成</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="统计方式：" label-width="100px" required>
                <el-radio-group v-model="taskForm.orderCountType" @change="handleChangeOrderCountType">
                  <el-radio :label="1" @input="taskForm.condition2 = ''">累计订单</el-radio>
                  <el-radio :label="0" @input="taskForm.condition2 = ''">单笔订单</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="统计类型：" v-if="taskForm.giveType == 1||taskForm.giveType == 2"  label-width="100px" required>
                <el-radio @change="countTypeChange" v-model="taskForm.countType" :label="1">按订单金额</el-radio>
                <el-radio @change="countTypeChange" v-model="taskForm.countType" :label="2">按商品件数</el-radio>
                <el-radio @change="countTypeChange" v-if="taskForm.orderCountType == 1" v-model="taskForm.countType" :label="3">按订单笔数</el-radio>
              </el-form-item>
              <el-form-item label="任务条件:"  label-width="100px" required>
                  <span v-if="taskForm.orderCountType == 0&&taskForm.giveType == 0">
                    每1个订单赠送1次抽奖机会
                  </span>
                  <span v-else-if="taskForm.orderCountType == 1&&taskForm.giveType == 0">
                    完成任务赠送1次抽奖机会
                  </span>
                  <span v-else-if="taskForm.giveType == 1">
                    <div v-for="(item,index) in taskLevelList" :key="index" style="margin-bottom: 6px;">
                      <span v-if="taskForm.countType == 1">每满<el-input placeholder="请输入金额" v-model="item.limit" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInput(e)}"/>元</span>
                      <span v-if="taskForm.countType == 2">每满<el-input placeholder="请输入件数" v-model="item.limit" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>件</span>
                      <span v-if="taskForm.countType == 3">每满<el-input placeholder="请输入笔数" v-model="item.limit" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>笔</span>
                      ，赠送 
                      <el-input v-model.number="item.giveNum" placeholder="请输入次数" style="width: 95px" @input="item.giveNum = getNumberData(1, $event, 0, 1,999)"></el-input>
                      次抽奖机会
                    </div>
                  </span>
                  <span v-else-if="taskForm.giveType == 2">
                    <div v-for="(item,index) in taskLevelList" :key="index" style="margin-bottom: 6px;">
                        <span v-if="taskForm.countType == 1">每满<el-input placeholder="请输入金额" v-model="item.limit" @change="(e)=>{item.limit = NumChange(e,'limit',index)}" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInput(e)}"/>元</span>
                        <span v-if="taskForm.countType == 2">每满<el-input placeholder="请输入件数" v-model="item.limit" @change="(e)=>{item.limit = NumChange(e,'limit',index)}" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>件</span>
                        <span v-if="taskForm.countType == 3">每满<el-input placeholder="请输入笔数" v-model="item.limit" @change="(e)=>{item.limit = NumChange(e,'limit',index)}"  style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>笔</span>
                        ，赠送 
                        <el-input v-model.number="item.giveNum" placeholder="请输入次数" style="width: 95px" @input="item.giveNum = getNumberData(1, $event, 0, 1,999)"></el-input>
                        次抽奖机会
                        <span  v-if="index>=2" @click="delTaskLevel(index)" style="cursor: pointer;"><i class="el-icon-error"></i></span>
                    </div>
                    <el-button :disabled="taskLevelList.length>=5" style="margin-right: 8px;width: auto;" @click="addTaskLevel">添加阶梯({{ taskLevelList.length }}/5)</el-button>
                  </span>
              </el-form-item>
              <el-form-item label="任务次数:" label-width="100px" required>
                  <span v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0">
                    活动期间最多完成
                    <el-input
                    v-model.number="taskForm.condition2"
                    placeholder="请输入"
                    style="width: 70px"
                    @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
                    ></el-input>
                    次
                  </span>
                  <span v-else-if="taskForm.giveType == 1 || taskForm.giveType == 2">
                    <el-radio v-model="taskForm.taskDoType" :label="0">不限制次数</el-radio>
                    <el-radio v-model="taskForm.taskDoType" :label="1">限制次数</el-radio>
                    <el-tooltip class="item" effect="light" content="限制该任务可活动抽奖次数上限" placement="bottom" style="margin-left: 8px">
                      <div style="width: 35px; display: inline-flex;cursor: pointer;">
                        <i class="el-icon-question" style="color: #ccc"></i>
                      </div>
                    </el-tooltip>
                    <div v-if="taskForm.taskDoType == 1">
                      活动期间最多获得<el-input v-model.number="taskForm.condition2" placeholder="请输入" style="width: 70px;margin: 0 4px;" @input="taskForm.condition = getNumberData(1, $event, 0, 1,999)"></el-input>次抽奖机会
                    </div>
                  </span>
                  <span v-else>{{taskForm.count}}</span>
              </el-form-item>
              <el-form-item label="任务失效:" label-width="100px" required v-if="taskForm.giveType==0&&taskForm.orderType==0&&taskForm.orderCountType==0">
                <el-checkbox v-model="taskForm.cancelOrderInvalid" :true-label="1" :false-label="0">用户取消订单后，抽奖机会或使用该抽奖机会的实物奖品失效</el-checkbox>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="任务条件:"  v-if="taskForm.type != 17" label-width="110px">
          <span v-if="taskForm.type == 13">
            成功浏览
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 4">
            成功加购
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 9">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 10">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次店铺，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 11">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次活动，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 12">
            每成功预约
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 16">
            每
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            积分可兑换1次机会
          </span>
          <span v-else-if="taskForm.type == 18">
            每成功邀请
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            个好友入会，赠送1次抽奖机会
          </span>
          <span v-else>{{taskForm.condition}}</span>
        </el-form-item>
        <el-form-item label="浏览商品:" label-width="110px" required v-if="taskForm.type == 13">
          <el-button class="normal-btn" type="primary" @click="showGoods(100)">选择商品（{{taskForm.skuIds.length}}/100）</el-button>
        </el-form-item>
        <el-form-item label="加购商品:" label-width="110px" required v-if="taskForm.type == 4">
          <el-button class="normal-btn" type="primary" @click="showGoods(100)">选择商品（{{taskForm.skuIds.length}}/100）</el-button>
        </el-form-item>
        <el-form-item label="分享商品:" label-width="110px" required v-if="taskForm.type == 9">
          <el-button class="normal-btn" type="primary" @click="showGoods(1)">选择商品（{{taskForm.skuIds.length}}/1）</el-button>
        </el-form-item>
        <el-form-item label="预约商品:" label-width="110px" required v-if="taskForm.type == 12">
          <div class="book-good-wrap">
            <el-button class="normal-btn" type="primary" @click="showGoods(100)">选择商品（{{taskForm.skuIds.length}}/100）</el-button>
            <span class="tip-red" style="margin-left:10px">注意：请添加预约商品，非预约商品无法完成任务</span>
          </div>
        </el-form-item>
        <el-form-item label="任务次数:" v-if="taskForm.type != 17" label-width="110px">
          <span v-if="taskForm.type == 12">
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 8">
            {{`活动期间内最多完成${taskForm.inviteLimit?taskForm.inviteLimit:0}次`}}
          </span>
          <span v-else-if="taskForm.type == 16">
            <el-select v-model="taskForm.activityType" placeholder="请选择">
              <el-option label="活动期间" :value="2"></el-option>
              <el-option label="每日" :value="1"></el-option>
            </el-select>
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 18">
            活动期间每日最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <!-- 购买商品 -->
          <span v-else>{{taskForm.count}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button style="margin-right: 8px;" @click="taskClose">取消</el-button>
        <el-button v-if="!taskIsLook" type="primary" @click="sureTask">确定</el-button>
      </div>
    </el-dialog>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
    <!-- 每日发放限额弹窗 -->
    <setLimitDialog
      :visible.sync="showLimitDialog"
      :init-data="limitData"
      :backgroundOpacity="backgroundOpacity"
      @confirm="handleLimitConfirm"
      @close="handleLimitClose"
    />
  </div>
</template>

<script>
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import { bigTurntableDraw, modifyBigTurn, getbigTurn, hdTaskTemplateGroup, sellerImage  } from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { updateCommon } from "@/api/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import tipBox from '@/components/tip-box'
import draggable from "vuedraggable";

import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/analysis/ware-controller";
import addPrizeNum from "./components/add-prize-num.vue";
import { checkOpenCrmByVenderType } from "@/api/public.js";
import setLimitDialog from '@/views/integralCenter/components/_components/setLimitDialog.vue'
import { getSellerInfo } from "@/api/sellerController";
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    tipBox,
    addPrizeNum,
    setLimitDialog,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.currentPrizeList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(5);
    },
    localStepNum(newVal) {
      if (newVal == 0) {
        // this.$nextTick(() => {
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "1" }), queryId);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "2" }), queryId2);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "3" }), queryId3);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "4" }), queryId4);
        // });
      }
    },
    // 监听 prizeSettingList 变化，自动同步到任务特定配置（除了中奖率）
    prizeSettingList: {
      handler(newVal, oldVal) {
        // 只有在任务特定配置存在时才进行同步
        if (Object.keys(this.taskPrizeConfigs).length > 0) {
          // 遍历所有任务类型的奖品配置
          for (const taskType in this.taskPrizeConfigs) {
            const taskPrizeList = this.taskPrizeConfigs[taskType];
            // 遍历通用奖品列表
            newVal.forEach((commonPrize, index) => {
              const correspondingTaskPrize = taskPrizeList.find(item => item.index === commonPrize.index);
              if (correspondingTaskPrize) {
                // 同步所有字段，除了 percentage 和 memberBuyPercentage
                for (const key in commonPrize) {
                  if (key !== 'percentage' && key !== 'memberBuyPercentage') {
                    this.$set(correspondingTaskPrize, key, commonPrize[key]);
                  }
                }
              }
            });
          }
        }
      },
      deep: true // 深度监听，确保能监听到对象内部属性的变化
    },
  },
  data() {
    return {
      customerPaperwork: {},
      isKeyActivity: 0,
      placementPosition: [],
      isPremissionShow: true,
      luckyDrawForm: 1,
      taskIsLook: false,
      actEndTime: "",
      isShowTip: false,
      // 1.14迭代 指定入会时间
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      isSelectProduct:true,
      mainImagelist: [],
      templateId: "",
      tabActive:0,
      navItem:{},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=12`,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      valueRow: null,
      echoDate: {},
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      pickerOptionsValue: {
        disabledDate: (time) => {
          if(this.ruleForm.endTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if(this.ruleForm.startTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      taskstartpickerOptionsValue: {
        disabledDate: (time) => {
          const endTime = this.taskForm.orderEndTime ? new Date(this.taskForm.orderEndTime).getTime() - 1 * 24 * 60 * 60 * 1000: null;
          const maxStartTime = endTime ? endTime - 90 * 24 * 60 * 60 * 1000 : null;
          return (
            (endTime && time.getTime() > endTime) ||
            (maxStartTime && time.getTime() < maxStartTime)
          );
        },
      },
      taskpickerOptionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.orderStartTime ? new Date(this.taskForm.orderStartTime).getTime() + 1 * 24 * 60 * 60 * 1000 : null;
          const maxEndTime = startTime ? startTime + 59 * 24 * 60 * 60 * 1000 : null;
          return (
            (startTime && time.getTime() < startTime) ||
            (maxEndTime && time.getTime() > maxEndTime)
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        ruleDescription: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
      },
      ruleForm: {
        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",

        goShopSetting:0, //进店设置
        goShopAppId: '',//小程序appId
        goShopUrl: '',//小程序页面路径,指定链接
      },
      sharePic: "",
      bigTurntable: {
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      bigTurntableDrawS: [
        // {
        //   assetsId: 0,
        //   logo: "string",
        //   giftType: 0,
        //   logo: "string",
        //   percentage: 0,
        //   price: 0,
        //   prizeType: 0,
        //   singleAmount: 0,
        //   title: "string",
        //   totalAmount: 0,
        // },
      ],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
      ],
      prizeSettingListOld:[],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,

      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      itemArr: [],
      raffleForm:{
        drawType:1,
        taskType:1,
        firstGiveTimes:null,
        everyDayGiveTimes:null,
        point: null,
        giveLimitType:0,
      },
      taskDialog:false,
      taskTypeOptions:[
        {
          label:'每日签到',
          value:1,
          taskCondition:'成功签到，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'浏览店铺',
          value:2,
          taskCondition:'成功浏店铺，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'浏览商品',
          value:13,
          taskCondition:'成功浏览XX件商品，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'加购商品',
          value:4,
          taskCondition:'成功加购XX件商品，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'分享商品',
          value:9,
          taskCondition:'成功分享XX件商品，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'分享店铺',
          value:10,
          taskCondition:'成功分享XX次店铺，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'分享活动',
          value:11,
          taskCondition:'成功分享XX次活动，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'好友助力',
          value:8,
          taskCondition:'每邀请1位好友，赠送1次抽奖机会',
          taskCount:'活动期间最多最多完成XX次'
        },
        {
          label:'浏览会场',
          value:5,
          taskCondition:'成功浏览会场，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'预约商品',
          value:12,
          taskCondition:'每成功预约XX件商品，赠送1次抽奖机会，最多完成YY次',
          taskCount:'活动期间最多完成YY次'
        },
        {
          label:'积分兑换',
          value:16,
          taskCondition:'每xx积分兑换1次机会',
          taskCount:'活动期间最多完成YY次'
        },
        {
          label: "购买商品",
          value: 17,
          taskCondition: "完成任务赠送1次抽奖机会",
          taskCount: "活动期间最多完成1次",
        },
        {
          label: "邀请好友入会",
          value: 18,
          taskCondition: "成功邀请XX个好友入会，赠送1次抽奖机会",
          taskCount: "活动期间最多完成YY次",
        },
      ],
      conditionValue:[13,4,9,10,11,12,16,17,18],
      goodsTypeList:[13,4,9,12],
      goodsLimitList:[13,4,12],
      rewardRulesOptions:[
        {
          value:0,
          label:'按固定次数赠送抽奖机会'
        },
        {
          value:1,
          label:'按倍数赠送抽奖机会'
        },
        {
          value:2,
          label:'按阶梯赠送抽奖机会'
        },
      ],
      taskLevelList:[],
      taskForm:{
        // 1.29迭代参数
        giveType:0,
        countType:1,
        taskDoType:0,

        type:1,
        taskTime:1,
        condition:null,
        condition2:null,
        count:null,
        endTime:null,
        startTime:null,
        skuIds:[],
        inviteLimit:null,
        jumpUrl:null,
        selectGoodsSkuList:[],
        activityType: 2,
        venderIds: [],
        sellerSkuList: [],
        cancelOrderInvalid: 0,
        orderPaymentType: 1,
        mergeOrder: false,
      },
      isTaskEdit:false,
      taskRow:{},
      taskDataList:[],
      goodsState:false,
      goodsLimit:100,
      selectGoodsSkuList:[],
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
      previousValue: 0,
      showLimitDialog: false, // 每日发放限额弹窗
      limitData: {}, // 初始数据
      // 概率配置类型：0-固定概率，1-按任务配置
      probabilityType: 0,
      probabilityConfigOptions: [
        {
          value: 0,
          label: '固定概率'
        },
        {
          value: 1,
          label: '按任务配置'
        }
      ],
      activeProbabilityTab: 'common', // 当前激活的tab
      selectedTaskTypes: [], // 选中的任务类型列表
      taskPrizeConfigs: {}, // 格式: { '1': [...], '2': [...] }
    };
  },
  computed:{
    // 获取任务类型
    getTaskType(){
      return (type)=>{
        const obj = this.taskTypeOptions.find(item=>item.value == type)
        if(obj){
          return obj.label
        } else {
          return '-'
        }
      }
    },
    // 获取任务条件
    getCondition(){
      return (item)=>{
        const {type,condition,condition2,orderCountType} = item
        let str = condition
        if(type == 13){
          str = `成功浏览${condition}件商品，赠送1次抽奖机会`
        }else if(type == 4){
          str = `成功加购${condition}件商品，赠送1次抽奖机会`
        }else if(type == 9){
          str = `成功分享${condition}次商品，赠送1次抽奖机会`
        }else if(type == 10){
          str = `成功分享${condition}次店铺，赠送1次抽奖机会`
        }else if(type == 11){
          str = `成功分享${condition}次活动，赠送1次抽奖机会`
        }else if(type == 12){
          str = `每成功预约${condition}件商品，赠送1次抽奖机会`
        }else if(type == 16){
          str = `每${condition}积分可兑换1次机会`
        }else if(type == 17){
          if(item.giveType == 0){
            str = orderCountType == 0 ? `每1个订单赠送1次抽奖机会`: `完成任务赠送1次抽奖机会`
          }else if(item.giveType == 1){
            this.taskLevelList.forEach(it=>{
              str = `购买商品，每满${item.countType == 1?it.limit+'元':item.countType == 2?it.limit+'件':item.countType == 3?it.limit+'笔':''}可赠送${it.giveNum}次抽奖机会`
            })
          }else if(item.giveType == 2){
            str = `购买商品：`
            this.taskLevelList.forEach(it=>{
              str = str +`\n满${item.countType == 1?it.limit+'元':item.countType == 2?it.limit+'件':item.countType == 3?it.limit+'笔':''}可赠送${it.giveNum}次抽奖机会；`
            })
          }
        }
        else if (type == 18) {
          str = `成功邀请好友入会${condition}次，赠送1次抽奖机会`
        }
        return str
      }
    },
    // 获取任务次数
    getCount(){
      return (item)=>{
        const {type,count,inviteLimit,condition2,activityType, orderCountType} = item
        let str = count
        if(type == 12){
          str = `活动期间最多完成${condition2}次`
        }else if(type == 8){
          str = `活动期间最多完成${inviteLimit}次`
        }else if(type == 16){
          str = `${activityType==2 ? '活动期间' : '活动期间每日'}最多完成${condition2}次`
        }else if(type == 17&&item.giveType == 0) {
          str = `活动期间最多完成${orderCountType == 0 ? condition2 : '1'}次`
        }else if(type == 17&&item.giveType != 0) {
          str = item.taskDoType == 0?'活动期间不限次数':`活动期间最多获得${item.condition2}次抽奖机会`
        }else if(type == 18){
          str = `活动期间每日最多完成${condition2}次`
        }
        return str
      }
    },
    // 可选择的任务列表（基于taskDataList）
    availableTaskOptions() {
      return this.taskDataList.map(task => {
        const taskType = this.taskTypeOptions.find(option => option.value === task.type);
        return {
          value: task.type,
          label: taskType.label
        };
      });
    },
    // 动态生成的概率配置tab列表
    dynamicProbabilityTabs() {
      const tabs = [{
        name: 'common',
        label: '通用概率'
      }];
      // 根据选中的任务类型添加tab
      this.selectedTaskTypes.forEach(taskType => {
        const taskOption = this.taskTypeOptions.find(option => option.value === taskType);
        if (taskOption) {
          tabs.push({
            name: `${taskType}`,
            label: taskOption.label
          });
        }
      });
      return tabs;
    },
    // 当前显示的奖品列表（根据选中的tab）
    currentPrizeList() {
      if (this.activeProbabilityTab === 'common') {
        return this.prizeSettingList;
      } else {
        // 如果是任务tab，返回对应任务的奖品配置
        if (!this.taskPrizeConfigs[this.activeProbabilityTab]) {
          // 如果该任务还没有配置，复制通用配置
          this.$set(this.taskPrizeConfigs, this.activeProbabilityTab,
            JSON.parse(JSON.stringify(this.prizeSettingList))
          );
        }
        return this.taskPrizeConfigs[this.activeProbabilityTab];
      }
    },
    // 判断当前是否为任务tab
    isTaskTab() {
      return this.activeProbabilityTab !== 'common';
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    }
  },
  created(){
    console.log('当前玩法id',this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
  },
  mounted() {
    this.prizeSettingListOld = this.prizeSettingList
    this.getSellerInfo();
    this.getLevel();
    this.getDetail();
    this.hdTaskTemplateGroup();
    console.log("当前玩法Data",this.activityData);
  },

  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    handleChangeOrderCountType() {
      this.taskForm.countType = 1
      this.taskForm.cancelOrderInvalid = 0;
    },
    handleChangeOrderType() {
      this.taskForm.cancelOrderInvalid = 0;
    },
    handleChangeSku(val) {
      if(val==0) {
        this.taskForm.sellerSkuList.forEach((item)=>{
          if(item.venderId == this.venderId) {
            item.skuIds = []
            this.selectGoodsSkuList = []
          }
        })
      }
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds&&this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
    },
    getSellerInfo() {
      getSellerInfo().then((res) => {
        res.data.permissions.forEach((item) => {
          if (item == "hide:interactive:product:offline") {
             this.isPremissionShow = false;
          } 
        });
      });
    },
    showSharePic(){
      if(this.luckyDrawForm == 3){
          this.sharePic = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/shareBlindBox.svg'
        }else if(this.luckyDrawForm == 4){
          this.sharePic = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/shareLuckyCard.svg'
        }else{
          this.sharePic = this.getDefaultSharePic(this.activityData.id)
        }
        this.ruleForm.sharePic = this.sharePic
    },
    handleInputPrice(value) {
      // 过滤非数字和非小数点字符
      let filteredValue = value.replace(/[^0-9.]/g, "");

      // 确保只保留第一个小数点
      const firstDotIndex = filteredValue.indexOf(".");
      if (firstDotIndex !== -1) {
        const beforeDot = filteredValue.slice(0, firstDotIndex + 1);
        const afterDot = filteredValue
          .slice(firstDotIndex + 1)
          .replace(/\./g, "");
        filteredValue = beforeDot + afterDot;
      }

      // 处理整数部分前导零
      if (firstDotIndex === -1) {
        // 非小数，若数字不为 0，移除前导零
        if (filteredValue !== "0") {
          filteredValue = filteredValue.replace(/^0+/, "");
        }
      } else {
        const integerPart = filteredValue.slice(0, firstDotIndex);
        const decimalPart = filteredValue.slice(firstDotIndex);
        // 若整数部分非空且以多个 0 开头，只保留一个 0
        const cleanedIntegerPart = integerPart.replace(/^0+(?=\d)/, "");
        filteredValue = cleanedIntegerPart + decimalPart;
      }

      // 确保小数点不在开头
      filteredValue = filteredValue.replace(/^\./, "0.");

      // 确保只保留三位小数
      if (firstDotIndex !== -1) {
        const decimalPart = filteredValue.slice(firstDotIndex + 1);
        filteredValue =
          filteredValue.slice(0, firstDotIndex + 1) + decimalPart.slice(0, 3);
      }

      return filteredValue;
    },
    // 控制大于0 - 正数可包含小数点
    inputValidateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = '999999.99'; // 设置为最大值
      }
      return newValue.replace(/^0+(\d)/, '$1');
    },
    inputValidateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = '999'; // 设置为最大值
      }

      return newValue;
    },
    countTypeChange(){
      this.taskLevelList.forEach(item=>{
        item.limit = ''
      })
    },
    NumChange(e,key,valueIndex){
      let res = e
      this.taskLevelList.forEach((item,index)=>{
        if(valueIndex>index){
          if(parseFloat(res)<=parseFloat(item[key])){
            res = ''
          }
        }
      })
      return res
    },
    giveTypeChange(e){
      this.taskForm.cancelOrderInvalid = 0;
      if(e == 1){
        this.taskLevelList = [
          {
            taskIndex:1,
            limit:'',
            giveNum:'',
          },
        ]
      }
      if(e == 2){
        this.taskLevelList = [
          {
            taskIndex:1,
            limit:'',
            giveNum:'',
          },
          {
            taskIndex:2,
            limit:'',
            giveNum:'',
          },
        ]
      }
    },
    addTaskLevel(){
      let postData = {
        taskIndex:1,
        limit:'',
        giveNum:'',
      }
      postData.taskIndex = this.taskLevelList.length + 1
      this.taskLevelList.push(postData)
    },
    delTaskLevel(index){
      this.taskLevelList.splice(index,1)
    },
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount
      };
      if( !this.toAddItem.title || this.toAddItem.title=="谢谢参与" ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = '';
      this.ruleForm.goShopUrl = '';
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    inp(val){
      this.$forceUpdate()
    },
    // 京东计划数量计算
    prizeNum(row){
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if([5,6,7,8,9].includes(Number(row.prizeType))){
        if(Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)){
          row.totalAmount = ""
          if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
          if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
          if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
          if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
          if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row){
      if(this.activityData.isStart){
        if(row.totalAmount < row.minNum && row.minNum){
          row.totalAmount = row.minNum
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
          this.$forceUpdate()
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      this.ruleForm.sharePic = this.sharePic
      this.$forceUpdate()
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate =  Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if(nowDate > startDate){
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      }else{
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);
      
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item,index){
      this.tabActive = index;
      this.navItem = item;
      this.getPolite()
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.getPolite()
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

     //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate()
    },

    nextStepKai(index, templateId = 0, item) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = index;
      if(templateId) {
        this.templateId = templateId
      }
      this.prizeSettingList = this.prizeSettingListOld
      if(item.layout == 1 || item.layout == 3) {
        this.luckyDrawForm = 1
      }else if(item.layout == 2) {
        this.luckyDrawForm = 2
      }else if(item.layout == 4) {
        this.luckyDrawForm = 3
        this.prizeSettingList = [...this.prizeSettingListOld, {
          index: 8,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        }]
      }  else if(item.layout==5){
        this.luckyDrawForm = 4
        this.prizeSettingList = this.prizeSettingListOld.slice(0, 6)
      }
      this.showSharePic()
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = this.activityData.id == 14 ? "http://yq-hd-rc.isvjcloud.com/shop.html" :"http://yq-hd-rc.isvjcloud.com/shop.html"
      const arr = [1, 8, 16, 17, 18, 19, 27, 28]
      if(arr.includes(Number(this.activityData.id))) {
        url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      }
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: this.activityData.id == 13 ? `${url}?image=${this.giftList[index].templateUrl}` : arr.includes(Number(this.activityData.id)) ? `${url}${this.giftList[index].secondImageUrl}` : `${url}?image=${this.giftList[index].templateExampleUrl}`
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (row.quantityTotal && row.price && row.totalAmount && row.prizeType == 2) {
          let numTotal = this.$jingdouTotal({ ...row, prizeCount: row.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimit(row,min) {
      let newVal = (row.dailyLimit+ "").replace(/[^\d]/g, '')
      if(newVal) {
        if(newVal<min) {
          return ""
        }else {
          if(Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return ""
          } else {
            return Number(row.dailyLimit)
          }
        }
      }
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 = "活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });
        text3 = "活动参与对象：" + levelText.splice(",");
      }
      if (this.ruleForm.condFollow == true) {
        text4 = "活动条件：关注店铺后方可参加活动";
      }
      if (this.raffleForm.drawType == 1) {
        text5 = `抽奖机会：`
        let count = 0
        if(this.raffleForm.taskType == 2){
          count += 1
          text5 += `\n（1）每人每天赠送抽奖机会${this.raffleForm.everyDayGiveTimes || 0}次`
        }else if(this.raffleForm.taskType == 1){
          count += 1
          text5 += `\n（1）每人首次赠送${this.raffleForm.firstGiveTimes|| 0}次`
        }
        this.taskDataList.forEach(list=>{
          const str = this.getCondition(list).replace(/\n/g,'')
          const str2 = this.getCount(list)
          text5 += `\n（${++count}）${str}，${str2}`
        })
      }else{
        if(this.raffleForm.point){
          text5 = "抽奖机会：用户消耗" + this.raffleForm.point + "积分抽奖一次";
        }
      }
      if (this.bigTurntable.oneDayMaxDrawNumber && this.bigTurntable.totalMaxDrawNumber) {
        if (this.bigTurntable.oneDayMaxRewardNumber && this.bigTurntable.totalMaxRewardNumber) {
          text6 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次，活动期间每人每天中奖不超过" +
            this.bigTurntable.oneDayMaxRewardNumber +
            "次, 累计中奖不超过" +
            this.bigTurntable.totalMaxRewardNumber +
            "次";
        } else if (this.bigTurntable.oneDayMaxRewardNumber) {
          text6 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次，活动期间每人每天中奖不超过" +
            this.bigTurntable.oneDayMaxRewardNumber +
            "次, 累计中奖不限次";
        } else if (this.bigTurntable.totalMaxRewardNumber) {
          text6 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次, 活动期间每人每天中奖不限次，累计中奖不超过" +
            this.bigTurntable.totalMaxRewardNumber +
            "次";
        } else {
          text6 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次";
        }
      }
      let plusText = ''
      // 1.14迭代 plus会员
      if(this.ruleDto.plusObject!=0){
        plusText =  `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}`;
      }else{
        plusText =  `Plus会员身份：不限`;
      }
      let Arr1 = [text1, text2, text3,plusText, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });

      // // 1.14迭代 plus会员
      // if(this.ruleDto.plusObject!=0){
      //   newText = newText + newNum + "." + `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}` + ";" + "\n";
      // }else{
      //   newText = newText + newNum + "." + `Plus会员身份：不限` + ";" + "\n";
      // }
      this.ruleForm.ruleDescription = newText;
    },
    //清除
    cleanData(row, index) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleMaxWin = "";
      row.memberBuyPercentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimitType = null;
      row.dailyLimit = null;
      row.busyLimit = null;
      row.idleLimit = null;
      this.winningRate = 0;
      // 同步清空所有任务表格中对应奖品的中奖率
      for (const taskType in this.taskPrizeConfigs) {
        const taskPrizeList = this.taskPrizeConfigs[taskType];
        const correspondingTaskPrize = taskPrizeList.find(item => item.index === index);
        if (correspondingTaskPrize) {
          // 清空中奖率相关字段
          correspondingTaskPrize.percentage = "";
          correspondingTaskPrize.memberBuyPercentage = "";
        }
      }
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(5);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      if(row.prizeType&&row.prizeType == 14){
        this.$message({
          message: "该奖品类型不支持修改",
          type: "warning",
        });
        return
      }
      // this.isSelectProduct = true;
      this.itemArr = this.prizeSettingList
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;
      this.echoDate = row;
      this.$refs.selectProduct.openDialog();
      console.log("this.JingdouCount.prizeCount", this.JingdouCount.prizeCount);
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, 2233);
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = Number(data.discount);
      this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      this.$set(this.prizeSettingList[this.index],'logo',data.logo);
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title = data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.prizeSettingList[this.index].skuId = data.skuId;
          this.prizeSettingList[this.index].addressFillEndTime = data.addressFillEndTime;
          this.prizeSettingList[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime;
          delete this.prizeSettingList[this.index].isGoodManage
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if([2,5,6,7,8,10].includes(Number(prizeType))){
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      console.log(this.prizeSettingList, 123);
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      console.log(this.prizeSettingList, "obj");
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      // 活动参与对象
      if (this.ruleForm.partner.length == 0) {
        this.$message.warning("请选择活动参与对象");
        return;
      }
            
      // 1.14迭代 这里判断 指定入会时间
      if(this.ruleDto.isCheckOpenCardTime&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
        return this.$message.warning("请选择入会时间");
      }

      // 抽奖机会
      if (this.raffleForm.drawType == 1) {
        let falg = false
        if(this.raffleForm.taskType == 1){
          if(!this.raffleForm.firstGiveTimes){
            // falg = true
          }
        }else{
          if(!this.raffleForm.everyDayGiveTimes){
            // falg = true
          }
        }
        if(falg){
          return this.$message.warning("请完善抽奖机会信息");
        }
      }else{
        if(!this.raffleForm.point){
          return this.$message.warning("请完善抽奖机会信息");
        }
      }
      // 请将奖品填写完整！
      let isFlay = false;

      this.prizeSettingList.forEach((item) => {
        if (item.prizeType != 9) {
          if (!item.totalAmount) {
            isFlay = true;
          }
        }
      });
      
      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }
      if(!this.useValidateMoreActSet(this)) {
        return;
      }

      //新增进店设置校验
      if(this.ruleForm.goShopSetting==1 && !this.ruleForm.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if(this.ruleForm.goShopSetting==2) {
        if(!this.ruleForm.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        }else if(!this.ruleForm.goShopUrl.startsWith('https://') || !this.ruleForm.goShopUrl.includes('jd.com')) {
          this.$message.warning("输入的内容非链接或为接口无法支持的链接，请重新设置");
          return;
        }
      }

      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.bigTurntableDrawRuleDTO = {};

      // 抽奖和中奖限制
      if(this.bigTurntable.oneDayMaxDrawNumber){
        obj.bigTurntableDrawRuleDTO.oneDayMaxDrawNumber = this.bigTurntable.oneDayMaxDrawNumber
      }
      if(this.bigTurntable.totalMaxDrawNumber){
        obj.bigTurntableDrawRuleDTO.totalMaxDrawNumber = this.bigTurntable.totalMaxDrawNumber
      }
      if(this.bigTurntable.oneDayMaxRewardNumber){
        obj.bigTurntableDrawRuleDTO.oneDayMaxRewardNumber = this.bigTurntable.oneDayMaxRewardNumber
      }
      if(this.bigTurntable.totalMaxRewardNumber){
        obj.bigTurntableDrawRuleDTO.totalMaxRewardNumber = this.bigTurntable.totalMaxRewardNumber
      }

      obj.bigTurntableDrawRuleDTO.shareTitle = this.ruleForm.shareTitle
      obj.bigTurntableDrawRuleDTO.shareIntroduce = this.ruleForm.shareIntroduce
      obj.bigTurntableDrawRuleDTO.sharePic = this.ruleForm.sharePic
      obj.luckyDrawForm = this.luckyDrawForm
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      obj.placementPosition = this.placementPosition.join(',');

      // 进店逛逛配置
      obj.bigTurntableDrawRuleDTO.goShopSetting = this.ruleForm.goShopSetting
      obj.bigTurntableDrawRuleDTO.goShopAppId = this.ruleForm.goShopAppId
      obj.bigTurntableDrawRuleDTO.goShopUrl = this.ruleForm.goShopUrl
      obj.bigTurntableDrawRuleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork)


      // 获取抽奖机会方式
      obj.bigTurntableDrawRuleDTO.drawType = this.raffleForm.drawType

      // 赠送限制
      obj.bigTurntableDrawRuleDTO.giveLimitType = this.raffleForm.giveLimitType

      // 任务赠送
      if(this.raffleForm.drawType == 1){
        if(this.raffleForm.taskType == 1){
          obj.bigTurntableDrawRuleDTO.firstGiveTimes = this.raffleForm.firstGiveTimes || 0;
        }
        if(this.raffleForm.taskType == 2){
          obj.bigTurntableDrawRuleDTO.everyDayGiveTimes = this.raffleForm.everyDayGiveTimes || 0
        }
      }else{
        // 消耗积分
        obj.bigTurntableDrawRuleDTO.point = this.raffleForm.point
      }
      // 任务
      if(this.taskDataList.length){
        obj.taskList = this.taskDataList.map(item=>{
          const obj = {
            activityType: item.type == 8 || item.type == 12 || (item.type==16&&item.activityType==2) ? 2 : 1,
            taskType:item.type,
            taskValidity:item.taskTime,
          }
          // 指定时间
          if(item.taskTime == 2){
            obj.startTime = item.startTime
            obj.endTime = item.endTime
          }
          // 商品
          if(item.skuIds.length){
            obj.skuIds = item.skuIds.join(",")
          }
          if(item.type == 18){
            obj.activityType = 2;
            obj.inviteLimit = item.condition;
            obj.taskDoLimit = item.condition2
          }
          // 浏览会场-跳转链接
          if(item.type == 5){
            obj.jumpUrl = item.jumpUrl
          }
          // 好友助力-邀请人数上限
          if(item.type == 8){
            obj.inviteLimit = item.inviteLimit
          }
          if(item.type == 17) {
            obj.activityType = 2;
            obj.orderCountType = item.orderCountType;
            obj.orderType = item.orderType
            obj.skuType = item.skuType
            // 指定商品规则，老数据无该字段时兜底为 0（整单计算）
            obj.statsSkuType = item.statsSkuType || 0
            obj.itemTotalLimit = item.itemTotalLimit
            obj.amtLimit = item.amtLimit
            obj.orderStartTime = item.orderStartTime
            obj.orderEndTime = item.orderEndTime;

            obj.giveType = item.giveType
            obj.countType = item.countType
            obj.taskDoType= item.taskDoType
            obj.stepList = item.stepList
            obj.skuIds = []
            obj.venderIds = item.venderIds.join(",");
            obj.sellerSkuList = item.sellerSkuList.map((item)=>{
              return {
                skuIds: item.skuIds,
                venderId: item.venderId,
              }
            });
            obj.cancelOrderInvalid = item.cancelOrderInvalid;
            obj.orderPaymentType = item.orderPaymentType;
            obj.mergeOrder = item.mergeOrder || false;
          }
          // 任务门槛上限
          if(this.conditionValue.includes(item.type)){
            if(item.type == 12){
              obj.giveLimit = item.condition
              obj.taskDoLimit = item.condition2
            } if(item.type == 16){
              obj.giveLimit = item.condition
              obj.taskDoLimit = item.condition2
            }else if(item.type == 4){
              // 加购商品
              obj.addCartLimit = item.condition
            } else if(item.type == 17) {
              obj.giveLimit = 1
              if(item.orderCountType == 0 || ((this.taskForm.giveType == 1 || this.taskForm.giveType == 2)&&this.taskForm.taskDoType == 1)) {
                obj.taskDoLimit = item.condition2
              }else {
                obj.taskDoLimit = 1
              }
            } else{
              obj.giveLimit = item.condition
            }
          }
          return obj
        })
      }else{
        obj.taskList = []
      }
      obj.bigTurntableDrawPrizeDTOS = this.deepClone(this.prizeSettingList);


      obj.bigTurntableDrawPrizeDTOS.forEach((item, index) => {
        item.percentage = Number(item.percentage);
        item.memberBuyPercentage = Number(item.memberBuyPercentage);
        if (item.prizeType != 9) {
          if (item.prizeType == 3||item.prizeType == 10) {
            item.assetsId = item.skuId || item.assetsId;
          } else {
            item.singleAmount = 1;
          }
          if (item.prizeType == 2 || item.prizeType == 4) {
            item.singleAmount = item.price;
          }
        }
      });

      obj.templateJson = this.templateJson; //多个模板
      obj.allowLevel = this.ruleForm.partner.join(","); //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,

      // 1.14迭代 这里提交
      obj.bigTurntableDrawRuleDTO.isCheckOpenCardTime = this.ruleDto.isCheckOpenCardTime
      obj.bigTurntableDrawRuleDTO.openCardStartTime = this.ruleDto.openCardStartTime
      obj.bigTurntableDrawRuleDTO.openCardEndTime = this.ruleDto.openCardEndTime
      obj.bigTurntableDrawRuleDTO.plusObject = this.ruleDto.plusObject

      obj.priceType = 0
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0
      obj.itemList = this.itemListFor //曝光商品集合
      obj.templateId = this.templateId

      // V2.5 => 复制，去除id和旧的模板数据
      if(this.activityData.isCopy){ 
        this.ids = "";
        delete obj.templateJson
      }

      // 概率配置
      obj.bigTurntableDrawRuleDTO.probabilityType = this.probabilityType;
      // 概率奖品设置
      obj.probabilityMap = Object.keys(this.taskPrizeConfigs).reduce((map, taskId) => {
        map[taskId] = this.taskPrizeConfigs[taskId].map(prize => ({
          prizeId: prize.id,
          prizeType: prize.prizeType,
          memberBuyPercentage: prize.memberBuyPercentage || 0,
          percentage: prize.percentage || 0
        }));
        return map;
      }, {});

      if (this.checked == true || this.isDraft) {
        if (this.ids == "" || this.isDraft || this.isDraftEdit) {
          if(this.isDraft){
            obj.status = 5
          }else{
            // 保存正式活动不需要status
            if(obj.status){
              delete obj.status
            }
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            obj.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
            delete obj.id
          }
          bigTurntableDraw(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          delete obj.templateJson
          let res;
          if(this.activityData.isStart){
            let params = {
              activityId: obj.id,
              // endTime: obj.endTime,
              ruleDto:obj.bigTurntableDrawRuleDTO,
              ruleDescription: obj.ruleDescription,
              prizes: obj.bigTurntableDrawPrizeDTOS.filter(item=>item.totalAmount).map(item=>{
                return {
                  prizeId: item.id,
                  totalAmount: !item.isWrite ? item.totalAmount : undefined,
                  dailyLimitType: item.dailyLimitType,
                  dailyLimit: item.dailyLimitType == '0' ? item.dailyLimit : '',
                  busyLimit: item.dailyLimitType == '1' ? item.busyLimit : '',
                  idleLimit: item.dailyLimitType == '1' ? item.idleLimit : '',
                  percentage: item.percentage,
                  memberBuyPercentage: item.memberBuyPercentage,
                  singleMaxWin: item.singleMaxWin,
                  isFollowActivityEndTime: item.isFollowActivityEndTime,
                  addressFillEndTime: item.addressFillEndTime
                }
              }),
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
            }
            if(this.actEndTime!=this.activityEndTime) {
              params.endTime = this.activityEndTime
            }
            // 概率奖品设置
            params.probabilityMap = Object.keys(this.taskPrizeConfigs).reduce((map, taskId) => {
              map[taskId] = this.taskPrizeConfigs[taskId].map(prize => ({
                prizeId: prize.id,
                prizeType: prize.prizeType,
                memberBuyPercentage: prize.memberBuyPercentage || 0,
                percentage: prize.percentage || 0
              }));
              return map;
            }, {});
            res = await updateCommon(params)
          }else{
            res = await modifyBigTurn(obj)
          }
          if (res && res.code == 1) {
            this.joinBlackList = false;
            this.$router.push({
              name: "throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
              },
            });
            this.$message.success(res.message);
          } else {
            if(res.message){
              this.$message.error(res.message);
            }else{
              this.$message.error(res.data.message);
            }
          }
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        getbigTurn(id)
          .then((res) => {
            res.data.partner = res.data.allowLevel?res.data.allowLevel.split(","):[]
            let data = res.data
            // tapd 进店逛逛
            data.goShopSetting = res.data.bigTurntableDrawRuleDTO.goShopSetting;
            data.goShopAppId = res.data.bigTurntableDrawRuleDTO.goShopAppId;
            data.goShopUrl = res.data.bigTurntableDrawRuleDTO.goShopUrl;
            this.ruleForm = data;
            // 是否重点活动回显
            this.isKeyActivity = res.data.isKeyActivity || 0;
            this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(',') : ["SHOP"];

            this.customerPaperwork = res.data.bigTurntableDrawRuleDTO.customerPaperwork ? JSON.parse(res.data.bigTurntableDrawRuleDTO.customerPaperwork) : {};
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            this.bigTurntable = res.data.bigTurntableDrawRuleDTO;
            this.ruleForm.shareTitle = res.data.bigTurntableDrawRuleDTO.shareTitle;
            this.ruleForm.shareIntroduce = res.data.bigTurntableDrawRuleDTO.shareIntroduce;
            this.ruleForm.sharePic = res.data.bigTurntableDrawRuleDTO.sharePic;
            // 获取抽奖机会方式回显
            this.raffleForm.drawType = res.data.bigTurntableDrawRuleDTO.drawType == 1?1:0
            // 赠送限制回显
            this.raffleForm.giveLimitType = res.data.bigTurntableDrawRuleDTO.giveLimitType || 0
            this.raffleForm.taskType = res.data.bigTurntableDrawRuleDTO.firstGiveTimes != null ? 1:2
            this.luckyDrawForm = res.data.luckyDrawForm

            // 1.14迭代 这里回显
            this.ruleDto = {
              isCheckOpenCardTime:res.data.bigTurntableDrawRuleDTO.isCheckOpenCardTime,
              openCardStartTime:res.data.bigTurntableDrawRuleDTO.openCardStartTime,
              openCardEndTime:res.data.bigTurntableDrawRuleDTO.openCardEndTime,
              plusObject:res.data.bigTurntableDrawRuleDTO.plusObject, //plus会员
            }
            
            if(res.data.bigTurntableDrawRuleDTO.drawType == 1){
              this.raffleForm.firstGiveTimes = res.data.bigTurntableDrawRuleDTO.firstGiveTimes?res.data.bigTurntableDrawRuleDTO.firstGiveTimes:null
              this.raffleForm.everyDayGiveTimes = res.data.bigTurntableDrawRuleDTO.everyDayGiveTimes?res.data.bigTurntableDrawRuleDTO.everyDayGiveTimes:null
            }else{
               this.raffleForm.point = res.data.bigTurntableDrawRuleDTO.point
            } 
            // 任务列表
            if(res.data.bigTurntableDrawRuleDTO.drawType ==  1){
              const goodsPromise = []
              this.taskDataList = res.data.taskList.map(item=>{
                const obj = {
                  type:item.taskType,
                  taskTime:item.taskValidity,
                  condition:null,
                  condition2:null,
                  count:null,
                  endTime:null,
                  startTime:null,
                  skuIds:[],
                  inviteLimit:null,
                  jumpUrl:null,
                  selectGoodsSkuList:[],
                  activityType:  item.taskType == 16 ? item.activityType : 2
                }
                // 指定时间
                if(item.taskValidity == 2){
                  obj.startTime = item.startTime
                  obj.endTime = item.endTime
                }
                // 商品
                if(item.skuIds){
                  obj.skuIds = item.skuIds.split(",")
                  let skuIdsLength = obj.skuIds.length;
                  let skuIds = obj.skuIds;
                  goodsPromise.push(getTaobaoItemListSku({ current: 1, size: skuIdsLength, skuIds: skuIds }))
                }
                // 浏览会场-跳转链接
                if(item.taskType == 5){
                  obj.jumpUrl = item.jumpUrl
                }
                // 好友助力-邀请人数上限
                if(item.taskType == 8){
                  obj.inviteLimit = item.inviteLimit
                }
                if (item.taskType == 18) {
                  obj.condition = item.inviteLimit
                  obj.condition2 = item.taskDoLimit
                }
                if(item.taskType == 17) {
                  obj.activityType = 2;
                  obj.orderCountType = item.orderCountType
                  obj.orderType = item.orderType
                  obj.skuType = item.skuType
                  // 指定商品规则，老数据无该字段时兜底为 0（整单计算）
                  obj.statsSkuType = item.statsSkuType || 0
                  // obj.skuIds = [],
                  obj.itemTotalLimit = item.itemTotalLimit
                  obj.amtLimit = item.amtLimit
                  obj.orderStartTime = item.orderStartTime
                  obj.orderEndTime = item.orderEndTime
                  obj.giveType = item.giveType
                  obj.countType = item.countType
                  obj.taskDoType= item.taskDoType,
                  this.taskLevelList = item.stepList?item.stepList:[]
                  this.selectGoodsSkuList = item.itemList ? item.itemList : []
                  obj.selectGoodsSkuList = item.itemList ? item.itemList : []
                  const venderIdList = 
                    item.venderIds
                      ? item.venderIds.split(",").map((item) => +item)
                      : [this.venderId];

                  const list = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                    skuIds: item.skuIds ? item.skuIds.split(",") : [],
                    venderId: this.venderId,
                    itemList: [],
                  }];
                  if(this.activityData.isCopy) {
                    obj.venderIds = [this.venderId]
                    obj.sellerSkuList = list.filter((row)=>{
                      if(row.venderId&&(row.venderId == this.venderId)){
                        return {
                          skuIds: item.skuIds,
                          venderId: this.venderId,
                          itemList: [],
                        }
                      }
                    })
                  } else {
                    obj.venderIds = venderIdList
                    obj.sellerSkuList = list
                  }
                  obj.cancelOrderInvalid = item.cancelOrderInvalid || 0;
                  obj.orderPaymentType = item.orderPaymentType===null? 1:item.orderPaymentType;
                  obj.mergeOrder = item.mergeOrder || false;
                }
                // 任务门槛上限
                const taskTypeObj = this.taskTypeOptions.find(option=>option.value == item.taskType)
                if(this.conditionValue.includes(item.taskType)){
                  if(item.taskType == 12){
                    obj.condition = item.giveLimit
                    obj.condition2 = item.taskDoLimit
                  }else if(item.taskType == 4){
                    obj.condition = item.addCartLimit
                    obj.count = taskTypeObj.taskCount
                  }else if(item.taskType == 16){
                    obj.condition = item.giveLimit
                    obj.condition2 = item.taskDoLimit
                    obj.activityType = item.activityType 
                  } else if (item.taskType == 17) {
                    obj.activityType = 2;
                    obj.condition = item.giveLimit
                    obj.condition2 = item.taskDoLimit
                    obj.count = taskTypeObj.taskCount
                  }else{
                    obj.condition = item.giveLimit
                    obj.count = taskTypeObj.taskCount
                  }
                }else{
                  obj.condition = taskTypeObj.taskCondition
                  obj.count = taskTypeObj.taskCount
                }
                return obj
              })
              Promise.all(goodsPromise).then(res=>{
                this.taskDataList.filter(item=>item.skuIds && item.skuIds.length).forEach((item,index)=>{
                  item.selectGoodsSkuList = res[index].data.records
                })
              })
            }
            // v2.5 => 复制不需要回显奖品和规则
            if(!this.activityData.isCopy){
              this.prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
              this.prizeSettingList.forEach((item, index) => {
                item.minNum = item.totalAmount
                item.index = index;
                item.isWrite = false
                if (item.percentage) {
                  this.winningRate += Number(item.percentage);
                }
              });
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            this.activityStartTime = res.data.startTime?res.data.startTime:null
            this.activityEndTime = res.data.endTime?res.data.endTime:null
            this.actEndTime = res.data.endTime;
            this.activityTimeChange();
            this.winningRate = this.winningRate.toFixed(5);
            console.log([String(res.data.startTime), String(res.data.endTime)]);
              
            // 概率配置
            this.probabilityType = res.data.bigTurntableDrawRuleDTO.probabilityType
            // 任务类型列表回显
            this.selectedTaskTypes = Object.keys(res.data.probabilityMap || {}).map(key => parseInt(key));
            // 概率奖品设置
            const probabilityMap = res.data.probabilityMap || {};
            this.taskPrizeConfigs = {};
            for (const taskType in probabilityMap) {
              const taskPrizeList = probabilityMap[taskType];
              this.taskPrizeConfigs[taskType] = taskPrizeList.map((prize, index) => {
                // 从 prizeSettingList 中找到对应的奖品信息
                const correspondingPrize = this.prizeSettingList.find(item =>
                  item.prizeId === prize.prizeId || item.index === index
                ) || {};
                return {
                  ...correspondingPrize,
                  memberBuyPercentage: prize.memberBuyPercentage,
                  percentage: prize.percentage,
                  prizeId: prize.prizeId,
                  prizeType: prize.prizeType,
                  index: index
                };
              });
            }

            this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
            this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
            this.selectGoodsArr = res.data.itemList;
            this.mainImagelist = res.data.itemList;
            this.itemListFor = res.data.itemList;
            // v2.5 => 复制不需要回显奖品和规则
            if(this.activityData.isCopy){
              this.ruleForm.ruleDescription = ""
            }
          })
          .catch((res) => {});
      } else {
        // 新增-默认活动时间
        this.activityStartTime = this.$getDate(30)[0]
        this.activityEndTime = this.$getDate(30)[1]
        this.activityTimeChange();
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null
      this.activityEndTime = null
    },
    // 清空任务时间
    clearTaskTime(){
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 清空下单时间
    clearOrderTime(){
      this.taskForm.orderStartTime = "";
      this.taskForm.orderEndTime = "";
    },
    // 控制大于0 - 正数可包含小数点
    validateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      this.taskForm.amtLimit = newValue.replace(/^0+(\d)/, '$1');
    },
    validateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999999) {
        newValue = '999999'; // 设置为最大值
      }

      this.taskForm.itemTotalLimit = newValue;
    },
    // 活动时间改变
    activityTimeChange() {
      this.ruleForm.startTime = this.activityStartTime;
      this.ruleForm.endTime = this.activityEndTime;
      this.$nextTick(() => {
        if(this.ruleForm.endTime && this.ruleForm.startTime){
          let nowTime = new Date().getTime();
          let start = new Date(this.ruleForm.startTime).valueOf();
          let end = new Date(this.ruleForm.endTime).valueOf();
          let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
          let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
          this.timeDay = Math.floor(
            Math.abs(
              new Date(this.ruleForm.endTime) -
                new Date(this.ruleForm.startTime)
            ) /
              1000 /
              60 /
              60 /
              24
          );
          //计算小时
          const date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
          const leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          // 查看不需要校验
          if(!this.backgroundOpacity){
            if (start < nowTime) {
              if (this.ids) {
                this.disableTime = true;
              } else {
              }
            }
            if (end < nowTime) {
              this.$message.warning("结束时间不能小于当前时间");
            }
            if (end < start) {
              this.$message.warning("结束时间不能小于开始时间");
              return;
            }
            if (end > invalidateDate) {
              this.$message.warning("活动时间不能超过软件有效期，请重新选择");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
            if (end > hdInvalidateDate) {
              this.$message.warning("活动时间不可超过互动数据授权有效期！");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
          }
        }
      });
    },

    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val,$index,type = 1) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }
      // 转换为数字进行计算
      const currentValue = parseFloat(val) || 0;
      // 计算当前所有奖项的中奖率总和（不包含当前正在编辑的项）
      let sumWithoutCurrent = 0;
      this.currentPrizeList.forEach((item, index) => {
        if (index !== $index && item.percentage) {
          sumWithoutCurrent += parseFloat(item.percentage);
        }
      });
      
      // 检查加上当前输入后是否超过100
      if (sumWithoutCurrent + currentValue > 100) {
        // 自动调整当前项的值，确保总和不超过100
        val = (100 - sumWithoutCurrent).toString();
      }

      let winningRate = 0;
      let totalMemberBuyPercentage = 0
      this.currentPrizeList.forEach((item,index) => {
        if (item.percentage) {
          winningRate += parseFloat(item.percentage).toFixed(5) * 1
        }
        if(type === 2){
          totalMemberBuyPercentage += item.memberBuyPercentage * 1;
        }
        if($index==index) {
          item.isWrite = true
        }
      });
      // 入会且已购中奖率
      if(type === 2){
        if (totalMemberBuyPercentage > 100) {
          val = String(100 - (totalMemberBuyPercentage - val));
        } else if (totalMemberBuyPercentage == 100) {
          if (val >= 100) {
            val = "100";
          } else {
            val = String(100 - (totalMemberBuyPercentage - val));
            if (val == 0) {
              val = "";
            }
          }
        }
      }
      
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      if(type==2) {
        return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
      } else {
       return val ? val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") : "";
      }
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 新增任务
    addTask(){
      this.isTaskEdit = false
      this.taskDialog = true
      this.taskForm = {
        giveType:0,
        countType:1,
        taskDoType:0,

        type:1,
        taskTime:1,
        condition:null,
        condition2:null,
        count:null,
        endTime:null,
        startTime:null,
        skuIds:[],
        selectGoodsSkuList:[],
        inviteLimit:null,
        jumpUrl:null,
        activityType: 2,
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        orderType: 0,
        orderCountType: 1,
        itemTotalLimit: null,
        amtLimit: null,
        orderEndTime: null,
        orderStartTime: null,
        venderIds: [],
        sellerSkuList: [],
        cancelOrderInvalid: 0,
        orderPaymentType: 1,
        mergeOrder: false,
      }
      this.selectGoodsSkuList = []
      this.taskTypeChange(1)
    },
    // 关闭
    taskClose(){
      this.taskIsLook = false
      this.taskDialog = false
    },
    // 任务类型change
    async taskTypeChange(e){
      if (e == 17) {
        let {
          code: code,
          message: message,
          data: data,
        } = await checkOpenCrmByVenderType();
        console.log(code, message, data);
        if (code == 1) {
        } else {
          // 条件不符合，恢复到之前的选择值
          this.$nextTick(() => {
            this.taskForm.type = this.previousValue;
          });
          if (message) {
            this.$message.warning(message);
            return;
          } else {
            this.$message.warning(data.message);
            return;
          }
        }
        this.initData()
      }
      this.previousValue = e;

      const obj = this.taskTypeOptions.find(item=>item.value == e)
      if(!this.conditionValue.includes(e)){
        this.taskForm.condition = obj.taskCondition
      }else{
        this.taskForm.condition = null
        this.taskForm.condition2 = null
        this.taskForm.activityType = 2
      }
      // 任务次数
      if(e == 12){
        this.taskForm.count = null
      }else{
        this.taskForm.count = obj.taskCount
      }
      // 购买商品 - tip：不能加入goodsTypeList 因为保存时不做限制
      if(this.taskForm.type == 17) {
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
        this.taskForm.giveType = 0
      }
      // 商品
      if(this.goodsTypeList.includes(e)){
        this.taskForm.skuIds = []
        this.selectGoodsSkuList = []
        this.taskForm.selectGoodsSkuList = []
      }
      this.taskForm.taskTime = 1
    },
    isMonotonicIncreasing(arr) {
      return arr.every((value, index, array) => {
        return index === 0 || parseFloat(value) > parseFloat(array[index - 1]);
      });
    },
    // 确认添加任务
    sureTask(){
      // 任务有效期
      if(this.taskForm.taskTime == 2){
        if(!this.taskForm.startTime || !this.taskForm.startTime){
          return this.$message.warning('请填写任务有效期')
        }
        if(this.taskForm.startTime && this.taskForm.endTime){
          const startTime = new Date((this.taskForm.startTime + " 00:00:00")).getTime()
          const endTime = new Date((this.taskForm.endTime + " 00:00:00")).getTime()
          const activityStartTime = new Date(this.activityStartTime).getTime() 
          const activityEndTime = new Date(this.activityEndTime).getTime()
          if(startTime > endTime){
            return this.$message.warning('结束时间不能小于开始时间')
          }
          if(activityStartTime > startTime || endTime > activityEndTime){
            return this.$message.warning('任务有效期超出了活动时间范围，请重新选择')
          }
        }
      }
      // 邀请人数上限
      if(this.taskForm.type == 8){
        if(!this.taskForm.inviteLimit){
          return this.$message.warning('请填写邀请人数上限')
        }
      }
      // 跳转链接
      if(this.taskForm.type == 5){
        if(!this.taskForm.jumpUrl){
          return this.$message.warning('请填写跳转链接')
        }
      }
      // 购买商品类型
      if(this.taskForm.type == 17) {
        // 下单时间-------------
        if(!this.taskForm.orderStartTime || !this.taskForm.orderEndTime){
          return this.$message.warning('请填写下单时间')
        }
        if(this.taskForm.orderStartTime && this.taskForm.orderEndTime){
          const startTime = new Date((this.taskForm.orderStartTime + " 00:00:00")).getTime()
          const endTime = new Date((this.taskForm.orderEndTime + " 00:00:00")).getTime()
          if(startTime > endTime){
            return this.$message.warning('下单结束时间不能小于下单开始时间')
          }
        }
        // 订单金额-------------
        if(!this.taskForm.amtLimit&&this.taskForm.giveType == 0){
          return this.$message.warning('请填写订单金额')
        }
        // 指定商品-------------
        if(this.taskForm.skuType == 1 && this.taskForm.selectGoodsSkuList.length == 0){
          return this.$message.warning('请选择指定商品')
        }
        if(this.taskForm.giveType == 1||this.taskForm.giveType == 2){
          let isLimit = false
          let isLimitZero = false
          this.taskLevelList.forEach(item=>{
            if(!item.limit||!item.giveNum){
              isLimit = true
            }
            if(item.limit == 0 && item.limit != ""){
              isLimitZero = true
            }
          })
          if(isLimitZero){
            return this.$message.warning('任务条件值需大于0')
          }
          if(isLimit){
            return this.$message.warning('请填写任务条件')
          }
          if(!this.taskForm.condition2&&this.taskForm.taskDoType == 1){
            return this.$message.warning('请填写任务次数')
          }
        }
        // 单笔订单-任务次数
        if(this.taskForm.orderCountType == 0 && !this.taskForm.condition2 && this.taskForm.giveType == 0){
          return this.$message.warning('请填写任务次数')
        }

        if(this.taskForm.giveType == 2){
          let limitArr = []
          let giveNumArr = []
          this.taskLevelList.forEach(item=>{
            limitArr.push(item.limit)
          })
          if(!this.isMonotonicIncreasing(limitArr)){
            return this.$message.warning('高级阶梯笔数需大于低级阶梯笔数')
          }
          if(!this.isMonotonicIncreasing(giveNumArr)){
            return this.$message.warning('高级阶梯抽奖机会需大于低级阶梯抽奖机会')
          }
        }

        if((this.taskForm.giveType == 1||this.taskForm.giveType == 2)&&this.taskForm.taskDoType == 1){
          let number = 0
          this.taskLevelList.forEach(item=>{
            number = Number(item.giveNum) + number
          })
          if(Number(this.taskForm.condition2)<number){
            return this.$message.warning('任务次数不可低于任务条件可得抽奖机会')
          }
        }
        console.log(this.taskForm,'6666');
      }

      // 任务条件
      if(this.conditionValue.includes(this.taskForm.type)&& this.taskForm.type != 17){
        if(!this.taskForm.condition){
          return this.$message.warning('请填写任务条件')
        }
      }
      // 商品
      if(this.goodsTypeList.includes(this.taskForm.type)){
        if(this.taskForm.skuIds.length == 0){
          const obj = this.taskTypeOptions.find(item=>item.value == this.taskForm.type)
          return this.$message.warning(`请填写${obj.label}`)
        }else if(this.goodsLimitList.includes(this.taskForm.type) && this.taskForm.condition > this.taskForm.skuIds.length){
          return this.$message.warning(`任务商品件数不得大于已选商品件数，请重新选择~`)
        }
      }
      // 任务次数
      if(this.taskForm.type == 12 ||this.taskForm.type == 16 || (this.taskForm.type == 17 && this.taskForm.orderCountType == 0 && this.taskForm.giveType == 0)){
        if(!this.taskForm.condition2){
          return this.$message.warning('请填写任务次数')
        }
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm))
      obj.stepList = JSON.parse(JSON.stringify(this.taskLevelList))
      console.log("obj", obj);
      // return;
      const index = this.taskDataList.findIndex(item=>item.type == this.taskForm.type )
      if(index != -1 && !this.isTaskEdit){
        return this.$message.warning('列表已存在该类型任务，请勿重复添加~')
      }else{
        // 修改
        if(this.isTaskEdit){
          const index = this.taskDataList.findIndex(item=>item.type == this.taskRow.type )
          this.taskDataList.splice(index,1,obj)
        }else{
          this.taskDataList.push(obj)
        }
      }
      this.taskDialog = false
    },
    // 修改
    editTask(row,isLook){
      const copyRow = JSON.parse(JSON.stringify(row))
      this.taskRow = row
      this.isTaskEdit = true
      this.taskForm = copyRow
      // 老数据无 statsSkuType 时兜底为 0（整单计算）
      this.taskForm.statsSkuType = copyRow.statsSkuType || 0
      // 商品回显
      this.selectGoodsSkuList = copyRow.selectGoodsSkuList
      this.taskDialog = true
      
      this.taskIsLook = isLook
      // 购买商品新增下单店铺回显处理
      if (this.taskForm.type == 17) {
        this.goodsLimit = 500
        this.initData();
        if(this.taskForm.skuType ==1) {
          const isReq = this.taskForm.sellerSkuList.some((item) => {
            return item.itemList&&item.itemList.length>0;
          });
          if (!isReq) {
          let list = this.taskForm.sellerSkuList.filter((item)=>item.venderId == this.venderId)
            const reqList = list.map((item) => {
              return getTaobaoItemListSku({
                current: 1,
                size: item.skuIds.length,
                skuIds: item.skuIds,
                venderId: item.venderId,
              });
            });
            Promise.all(reqList).then((res) => {
              res.forEach((itemRes, index) => {
                this.taskForm.sellerSkuList[index].itemList = itemRes.data.records;
                this.selectGoodsSkuList = itemRes.data.records
              });
            });
          }
        }
      } else {
        this.goodsLimit = 100
      }
    },
    // 删除
    deleteTask(row){
      const index = this.taskDataList.findIndex(item=>item.type == row.type )
      this.taskDataList.splice(index,1)
    },
    // 上移
    upTask(index){
      this.taskDataList[index] = this.taskDataList.splice(index - 1,1,this.taskDataList[index])[0]
    },
    // 下移
    downTask(index){
      this.taskDataList[index] = this.taskDataList.splice(index + 1,1,this.taskDataList[index])[0]
    },
    // 商品组件回调
    selectGoodsChange(val) {
      if (val) {
        let isGoods = false
        val.forEach(item=>{
          if(item.skuStatus != 1){
            isGoods = true
          }
        })
        if(this.isPremissionShow){
          if(isGoods){
           return this.$message.warning('当前所选商品包含下架商品，请重新选择')
          }
        }
        let valArr = [];
        this.selectGoodsSkuList = val
        this.taskForm.selectGoodsSkuList = val;
        this.taskForm.sellerSkuList.forEach((item)=>{
          if(item.venderId == this.venderId){
            item.skuIds = valArr
          }
        })
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        console.log(valArr)
        this.taskForm.skuIds = valArr
      }
      this.goodsState = false;
    },
    // 商品弹窗
    showGoods(limit){
      this.goodsLimit = limit
      this.goodsState = true
    },
    // 每日发放限额弹窗
    setLimit(row) {
      if (!row.totalAmount) {
        return this.$message.warning("请先输入奖品总数");
      }
      this.showLimitDialog = true
      this.limitData = row
    },
    // 每日发放限额弹窗确认
    handleLimitConfirm(data) {
      console.log('配置数据：', data)
      this.$set(this.limitData, 'dailyLimitType', data.dailyLimitType)
      this.$set(this.limitData, 'dailyLimit', data.dailyLimit)
      this.$set(this.limitData, 'idleLimit', data.idleLimit)
      this.$set(this.limitData, 'busyLimit', data.busyLimit)

      if (data.dailyLimitType == 0) { // 每日发放
        this.$delete(this.limitData, 'idleLimit')
        this.$delete(this.limitData, 'busyLimit')
      } else if (data.dailyLimitType == 1) { // 按闲忙时配置数量
        this.$delete(this.limitData, 'dailyLimit')
      }
    },
    // 每日发放限额弹窗取消
    handleLimitClose() {
      console.log('弹窗关闭')
    },
    handleTabClick(tab) {
      console.log('切换到tab:', tab.name);
      this.activeProbabilityTab = tab.name;
      // 如果切换到任务tab且该任务还没有配置，复制通用配置
      if (tab.name !== 'common' && !this.taskPrizeConfigs[tab.name]) {
        this.$set(this.taskPrizeConfigs, tab.name, 
          JSON.parse(JSON.stringify(this.prizeSettingList))
        );
      }
      // 重新计算累计中奖率
      this.winningRate = 0;
      this.currentPrizeList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(5);
    },
    handleProbabilityChange(selectedValues) {
      // 如果值为1, 且任务列表为空, 则重新选择为0, 且提示
      if(selectedValues == 1 && this.taskDataList.length == 0){
        this.probabilityType = 0
        this.$message.warning('请先添加任务')
      }
    },
    // 处理任务类型选择变化
    handleTaskTypesChange(selectedValues) {
      console.log('选中的任务类型:', selectedValues);
      // 清理不再选中的任务配置
      Object.keys(this.taskPrizeConfigs).forEach(taskKey => {
        const taskType = taskKey.replace('task_', '');
        if (!selectedValues.includes(parseInt(taskType))) {
          this.$delete(this.taskPrizeConfigs, taskKey);
        }
      });
      // 如果当前激活的tab对应的任务被取消选择，切换回通用tab
      if (this.activeProbabilityTab !== 'common') {
        const currentTaskType = this.activeProbabilityTab.replace('task_', '');
        if (!selectedValues.includes(parseInt(currentTaskType))) {
          this.activeProbabilityTab = 'common';
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #7b61ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #7b61ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #7b61ff;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #7b61ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #7b61ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #7b61ff;
        border-bottom: 1px solid #7b61ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #7b61ff;
        border-left: 1px solid #7b61ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#7B61FF;
      background: rgba(123,97,255,0.1);
      border: 1px solid #7B61FF;
      &:hover{
        color: #fff;
        background: #7B61FF;
      }
    }
    .reset{
      color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.task-btn-wrap{
  margin-bottom: 16px;
}
.task-tip{
  margin-bottom: 16px;
}
.normal-btn{
  width: auto!important;
}
.task-tip-wrap{
  padding-right: 10%;
}
.task-wrap{
  display: flex;
  align-items: center;
  &-radio{
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  //   .el-step__line {
  //     background-color: #7B61FF;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  // }
  // .el-step__title.is-process {
  //   color: #7B61FF;
  // }
  // .el-step__title.is-success {
  //   color: #7B61FF;
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.rule_box {
  // width: 1000px;
  // height: 217px;
  margin-top: 8px;
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.ml12 {
  margin-left: 12px;
}
.ml8 {
  margin-left: 8px;
}
</style>
